function paramsToStatsKey(params) {
    const whitelist = [
        'list',
        'articleGroup',
        'language',
        'material',
        'shape',
        'grade',
        'innerDiameter',
        'outerDiameter',
        'wallThickness',
        'inStock',
    ];
    return JSON.stringify(Object.fromEntries(Object.entries(params).filter(([key]) => whitelist.includes(key))));
}
export const statsCache = {
    cache: new Map(),
    has(params) {
        return this.cache.has(paramsToStatsKey(params));
    },
    setIfDefined(params, stats) {
        this.cache.set(paramsToStatsKey(params), stats);
    },
    get(params) {
        return this.cache.get(paramsToStatsKey(params));
    },
};
